import Modal from "react-bootstrap/esm/Modal";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/esm/Button";
import {Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";

const SendToAiModal = ({show, setShow, reportType, selectedRows, filters, successfulCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [consoleLines, setConsoleLines] = useState([]);

    useEffect(() => {
        setLoading(false);
        setConsoleLines([]);
    }, []);

    const sendToAi = () => {
        setLoading(true);
        let invTypes = [];
        if(filters?.invoiceType?.length > 0) {
            filters.invoiceType.forEach((obj) => {
                invTypes.push(obj.value);
            })
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/mass-send-to-ai`, {
            reportType: reportType,
            selectedRows: selectedRows,
            filters: {...filters, invoiceType: invTypes},
            company: company.id,
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής άντληση.");
                setConsoleLines(res.data.consoleLines);
                if (typeof successfulCallback === "function") successfulCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleHide = () => {
        if (loading) {
            toast.info("Παρακαλώ περιμένετε μέχρι να τελειώσει η εργασία.");
        } else {
            setShow(false);
        }
    }

    return (
        <Modal show={show} onHide={() => handleHide()} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Μαζική αποστολή παραστατικών στο Primer AI</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                ΠΡΟΣΟΧΗ! Θα γίνει μαζική αποστολή των {selectedRows.length > 0 ? "επιλεγμένων" : "φιλτραρισμένων"} παραστατικών προς το Primer AI για χαρακτηρισμό και δημιουργία αγοράς.<br />
                Θα αποσταλούν ΜΟΝΟ τα παραστατικά που δεν υπάρχουν ή δεν έχουν χαρακτηριστεί απο το Primer ERP καθώς θα γίνει και επαναποστολή των παραστατικών που απέτυχαν με κάποιο σφάλμα.<br />
                Είστε σίγουροι ότι θέλετε να συνεχίσετε?
                {consoleLines.length > 0 && (
                    <React.Fragment>
                        <h5 style={{textAlign: "center"}} className={"mt-2"}>Κονσόλα:</h5>
                        <div style={{height: "300px", overflowY: "scroll", border: "1px solid gray", padding: "5px"}}
                             className={"mb-3"}>
                            {consoleLines.length > 0 && consoleLines.map((line) => (
                                <span>{line}<br/></span>
                            ))}
                        </div>
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => sendToAi()} disabled={loading}>
                    Εκτέλεση διαδικασίας {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SendToAiModal;